import { render, staticRenderFns } from "./kontorDurum.vue?vue&type=template&id=676d8038&"
import script from "./kontorDurum.vue?vue&type=script&lang=js&"
export * from "./kontorDurum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports